import { render, staticRenderFns } from "./WorkpostLaserPage.vue?vue&type=template&id=d9bcca66"
import script from "./WorkpostLaserPage.vue?vue&type=script&lang=js"
export * from "./WorkpostLaserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports